const Specificaitons = () => {
  return <h1>Specificaitons</h1>;
};

export default Specificaitons;
